import React from 'react'

import type { MenuPlacement } from 'react-select'

import { Dropdown, type DropdownOption } from '@/components/ui'

interface Params {
  label: string
  value?: string
  onChange: (value?: string) => void
  options: { label: string; value: string; isDefault?: boolean }[]
  placeholder?: string
  menuPlacement?: MenuPlacement
}

export const DateOptions = [
  { label: 'All', value: '' },
  { label: 'Last Hour', value: 'lastHour' },
  { label: 'Today', value: 'today' },
  { label: 'Yesterday', value: 'yesterday' },
  { label: 'This Week', value: 'thisWeek' },
  { label: 'Last Week', value: 'lastWeek' },
  { label: 'This Month', value: 'thisMonth' },
  { label: 'Last 30 Days', value: 'previous1Month' },
  { label: 'Custom', value: 'custom' },
]
export const NonAlarmDateOptions = [
  { label: 'Today', value: 'today' },
  { label: 'Yesterday', value: 'yesterday' },
  { label: 'This Week', value: 'thisWeek' },
  { label: 'Last Week', value: 'lastWeek' },
  { label: 'Last 30 Days', value: 'previous1Month' },
]

export const NonAlarmDateOptionsWithCustom = [
  { label: 'Today', value: 'today' },
  { label: 'Yesterday', value: 'yesterday' },
  { label: 'This Week', value: 'thisWeek' },
  { label: 'Last Week', value: 'lastWeek' },
  { label: 'Last 30 Days', value: 'previous1Month' },
  { label: 'Custom', value: 'custom' },
]

export const CustomSingleSelect: React.FC<Params> = ({
  value,
  onChange,
  label,
  options,
  placeholder,
  menuPlacement,
}) => {
  const handleSingleSelectItem = React.useCallback(
    (opt: DropdownOption | null) => {
      onChange(opt?.value || undefined)
    },
    [onChange]
  )
  return (
    <div>
      <label>{label}</label>
      <Dropdown
        options={options}
        handleSingleSelectItem={handleSingleSelectItem}
        selectedItem={options.find((o) => o.value === value) || options.find((o) => o.isDefault) || options[0]}
        placeholder={placeholder}
        menuPlacement={menuPlacement}
      />
    </div>
  )
}
